export function timeFilter ( time ) {

    if (!time) return ''
  
    let type
    if (typeof(time) == 'string') time = new Date(time)
    if (Object.keys(time).length) {
      type = time.type
      time = time.time
    }
  
    let year = time.getFullYear()
    let month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1
    let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
  
    let hours = time.getHours() < 10 ? "0" + (time.getHours()) : time.getHours()
    let minutes = time.getMinutes() < 10 ? "0" + (time.getMinutes()) : time.getMinutes()
    let seconds = time.getSeconds() < 10 ? "0" + (time.getSeconds()) : time.getSeconds()
  
    if (type == 1) {
      return `${year}-${month}-${day}`
    } else {
  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
    
  }
  
  export function toTimestamp ( time ) {
  
  let d = new Date(time)
  
  return d.getTime() / 1000
  
  }
  
  export function nowTime() {
  let time = new Date()
  
  let year = time.getFullYear()
  let month = (time.getMonth() + 1)  < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1
  let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
  let hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
  let minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()
  let seconds = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds()
  
  return `${year}-${month}-${day} ${hours}时${minutes}分${seconds}秒`
  }
  
  /* 
    判断数据类型 
    
    data: any - 数据 - 返回数据类型  *首字母大写* 
  
    type: String - 则返回data数据类型与type的比较 - true | false
          Array -  则满足其中一项判断返回 true, 全不满足返回 false 
                         
  */
  
  export let nicTypeOf = (data, type) => {
    
    let s = Object.prototype.toString.call(data).split(' ')[1]  // [Object xxx]
  
    let dataType = s.substr(0, s.length - 1)
  
    if (type) {
  
      if (Array.isArray(type)) {
  
        let r = type.some(t => t === dataType)
  
        return r
      }
  
      return dataType === type
    } 
  
    return dataType
  }
  
  /**
  * 深度拷贝
  * @param obj
  * @returns {*}
  */
  export function deepCopy(obj) {
  let result = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] != null ) {  // typeof null 也会是object, 需要特别判断
        result[key] = deepCopy(obj[key]);   //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
  }
  
  /**
  * 矩形边界检测-碰撞检测法
  * 两个矩形中心点在x方向的距离的绝对值小于等于矩形宽度和的二分之一，同时y方向的距离的绝对值小于等于矩形高度和的二分之一
  * @param {*} frameRect 
  * @param {*} itemRect 
  */
  export function checkByRectCollisionDetection(frameRect,itemRect) {
  var x1 = frameRect.x + frameRect.w / 2,
      y1 = frameRect.y + frameRect.h / 2,
      w1 = frameRect.w,
      h1 = frameRect.h;
  var x2 = itemRect.x + itemRect.w / 2,
      y2 = itemRect.y + itemRect.h / 2,
      w2 = itemRect.w,
      h2 = itemRect.h;
  if(Math.abs(x1 - x2) < ((w1 + w2) / 2) && Math.abs(y1 - y2) < ((h1 + h2) / 2)) 
      return true;
  else
      return false;
  }
  
  /**
  * 计算两线段之间的夹角 ( 同一个中心点 )
  * 
  * @param {*}  // {开始坐标x - 中心点坐标x, 开始坐标y - 中心点坐标y}
  * @param {*}  // {结束坐标x - 中心点坐标x, 结束坐标y - 中心点坐标y}
  */
  
  export function getAngle ({ x: x1, y: y1 }, { x: x2, y: y2 }) {
  const dot = x1 * x2 + y1 * y2
  const det = x1 * y2 - y1 * x2
  const angle = Math.atan2(det, dot) / Math.PI * 180
  return Math.round(angle + 360) % 360
  }
  
  /* position封装 */
  export let setPosition = (item) => {
  let {
      cplaceX: x,
      cplaceY: y,
      careaLength: h,
      careaWidth: w,
  } = item
  
  return { x, y, h, w }
  }


/* 
  直接读取前端upload中的文件, <input type="file" />
*/
export function readerFile (params) {
  let reader = new FileReader()

  reader.readAsText(params.file)

  reader.onload = ()=>{
      console.log(reader.result)   // reader.result为获取结果
  }
}